import React from 'react';

const BlogCard = ({ blog: { name, image, description, published_url, published_date } }) => {
    return (
        <div className="col col-d-6 col-t-6 col-m-12">
            <div className="box-item">
                <div className="image">
                    <a href="blog-post-new.html">
                        <img src={image} alt={name} />
                        <span className="info">
                            <span className="ion ion-document-text"></span>
                        </span>
                    </a>
                </div>
                <div className="desc">
                    <a href={published_url}>
                        <span className="date"> {published_date}</span>
                    </a>
                    <a href="blog-post-new.html" className="name"> {name} </a>
                    <div className="text">
                        <p> {description} </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlogCard;